<template>
    <div class="marquee-section" v-if="areaIsShow">
      <div class="marquee-container-box">
        <div class="text-area" v-if="areaTitleIsShow">
            <h1 class="area-title">{{ areaTitle }}</h1>
            <h2 class="area-title-new">{{ areaTitleNew }}</h2>
        </div>
        <!-- 右侧跑马灯 -->
        <div class="marquee-container" :style="{width:areaTitleIsShow ? '88%' : '100%'}">
          <div class="semi-transparent-box"></div>
          <div 
            class="marquee-content"
            ref="marqueeRef"
          >
            <div class="brand-logos">
              <img 
                :src="brandLogos" 
                alt="Brand Logos"
                class="logo-strip"
                @load="onImageLoad"
              >
            </div>
            <div class="brand-logos">
              <img 
                :src="brandLogos" 
                alt="Brand Logos"
                class="logo-strip"
                @load="onImageLoad"
              >
            </div>
            <div class="brand-logos">
              <img 
                :src="brandLogos" 
                alt="Brand Logos"
                class="logo-strip"
                @load="onImageLoad"
              >
            </div>
            <div class="brand-logos">
              <img 
                :src="brandLogos" 
                alt="Brand Logos"
                class="logo-strip"
                @load="onImageLoad"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import { ref, onMounted, onUnmounted } from 'vue';
    import { homeApi } from '@/api/home'; // 确保导入你的 API 模块
    
    export default {
      setup() {
        const brandLogos = ref('');
        const marqueeRef = ref(null);
        const areaTitle = ref('');
        const areaTitleNew = ref('');
        const areaIsShow = ref(false);
        const areaTitleIsShow = ref(false);
        const startAnimation = () => {
          if (marqueeRef.value) {
            marqueeRef.value.classList.add('animate');
          }
        };
    
        const onImageLoad = () => {
          startAnimation();
        };
    
        const fetchData = async () => {
          try {
            const response = await homeApi.getBar();
            const data = response.data;
    
            // 根据设备类型选择合适的图片 URL
            if (window.innerWidth <= 768) {
              // 移动端
              brandLogos.value = data.mobile_pic;
              
            } else {
              // PC端
              brandLogos.value = data.pc_pic;
            }
         // 更新 areaIsShow
       areaIsShow.value = data.area_show == '1';
       areaTitleIsShow.value = data.area_title_show == '1';

        // 更新其他数据
        areaTitle.value = data.area_title;
        areaTitleNew.value = data.area_title_new;
           
            // console.log(areaIsShow.value)
            // 如果图片已经加载，直接开始动画
            const img = new Image();
            img.src = brandLogos.value;
            if (img.complete) {
              startAnimation();
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        onMounted(() => {
          fetchData();
        });
    
        onUnmounted(() => {
          if (marqueeRef.value) {
            marqueeRef.value.classList.remove('animate');
          }
        });
    
        return {
          marqueeRef,
          onImageLoad,
          brandLogos,
          areaTitle,
          areaTitleNew,
          areaIsShow,
          areaTitleIsShow
        };
      }
    }
    </script>
  
  <style scoped>
    .marquee-container-box {
      height: 500px; /* 可以根据需要调整高度 */
      position: relative;
      align-items: center;
      display: flex;
      overflow: hidden;
      width:88vw;
      max-width: 1680px;
      margin: 0 auto;
    
      margin-top: 10px;
    }
    .text-area {
      text-align: center;
      margin-bottom: 20px;
      width: 40%;
    }

    .area-title {
      font-size: 56px;
      font-weight: bold;
      color: #007bff;
    }

    .area-title-new {
      font-size: 42px;
      color: #fff;
    }

  .marquee-section {
     margin-bottom: 10px;
      position: relative;
      background-color: #000;
  }
  
  .background-pattern {
    width: 40%; /* 左侧背景占40%宽度 */
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  
  .pattern-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left center; /* 图案靠左对齐 */
  }
  
  .marquee-container {
    width: 60%; /* 右侧跑马灯占60%宽度 */
    height: 120px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin: 0 30px;
  }
  .semi-transparent-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle, transparent, transparent, #000);
    z-index: 10;
}
  .marquee-content {
    display: flex;
    position: relative;
  }
  
  .brand-logos {
    flex-shrink: 0;
  }
  
  .logo-strip {
    display: block;
    height: auto;
    max-height: 120px; /* 可以根据需要调整logo高度 */
    object-fit: contain;
  }
  
  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  .marquee-content.animate {
    animation: marquee 60s linear infinite;
    will-change: transform;
  }
  
  .marquee-container:hover .marquee-content.animate {
    animation-play-state: paused;
  }
  
  /* 响应式设计 */
  @media screen and (max-width: 768px) {
    .marquee-container-box{
      width: 100%;
      height: 240px;
      margin-top: 80px;
      flex-direction: column;
      justify-content: center;
    }
    .text-area {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
      padding: 0 20px;
    }

    .area-title {
      font-size: 24px;
      font-weight: bold;
      color: #007bff;
    }

    .area-title-new {
      font-size: 24px;
      color: #fff;
    }
    .marquee-section {
      height: auto;
      height: 240px;
      margin-bottom: 10px;
    }
  
    .background-pattern {
      width: 100%;
      height: 200px;
    }
  
    .marquee-container {
      width: 50%;
      padding: 0;
      height: 80px;
      /* margin-left: 0; */
      margin: 0;
    }
  
    .logo-strip {
      max-height: 60px;
    }
  }
  </style>